import { Home, BarChart2, Search, LogOut } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Button } from "./ui/button";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export function DesktopNavigation() {
  const location = useLocation();
  const navigate = useNavigate();
  
  const navigation = [
    {
      name: "Feed",
      href: "/",
      icon: Home,
    },
    {
      name: "Analytics",
      href: "/analytics",
      icon: BarChart2,
    },
    {
      name: "Search",
      href: "/search",
      icon: Search,
    },
  ];

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
      localStorage.clear();
      navigate("/login", { replace: true });
      toast.success("Logged out successfully");
    } catch (error) {
      console.error('Logout error:', error);
      toast.error("Error logging out");
      localStorage.clear();
      navigate("/login", { replace: true });
    }
  };

  return (
    <nav className="hidden md:flex items-center space-x-8">
      {navigation.map((item) => {
        const isActive = location.pathname === item.href;
        return (
          <Link
            key={item.name}
            to={item.href}
            className={cn(
              "flex items-center space-x-2 px-3 py-2 rounded-md transition-colors",
              isActive
                ? "text-nutrition-600 bg-nutrition-50"
                : "text-gray-600 hover:text-nutrition-500 hover:bg-nutrition-50"
            )}
          >
            <item.icon className="h-5 w-5" />
            <span>{item.name}</span>
          </Link>
        );
      })}
      <Button variant="outline" onClick={handleLogout} className="ml-4">
        <LogOut className="mr-2 h-4 w-4" />
        Logout
      </Button>
    </nav>
  );
}